var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4034_38995)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 4,
    width: 24,
    height: 24,
    rx: 4,
    fill: "#E85E00"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 4.5,
    width: 23,
    height: 23,
    rx: 3.5,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8168 8.68187C19.012 8.64576 19.2131 8.66828 19.3943 8.74632L19.4704 8.78343L19.5434 8.8264C19.6851 8.91848 19.801 9.04511 19.8806 9.19424L19.9177 9.27041L19.9477 9.34984C20.0098 9.53687 20.0152 9.73868 19.9626 9.92992C19.9603 9.93854 19.9582 9.94744 19.9555 9.95596L18.6755 13.969L18.6644 14.0002H23.3331C23.5847 13.9997 23.8315 14.0702 24.0447 14.204C24.2583 14.3381 24.4292 14.5305 24.5381 14.758C24.647 14.9856 24.6895 15.2393 24.6599 15.4898C24.6303 15.7404 24.5298 15.9775 24.3708 16.1734C24.3584 16.1887 24.3455 16.2036 24.3318 16.2177L17.7315 23.0178L17.7309 23.0172C17.585 23.1731 17.3939 23.2796 17.1833 23.3186C16.9603 23.3598 16.7297 23.324 16.5297 23.217C16.3297 23.11 16.1719 22.9378 16.0824 22.7294C15.993 22.521 15.9774 22.2885 16.0375 22.0699L16.0447 22.0438L17.3246 18.0308L17.3357 18.0002H12.6664V17.9996C12.415 17.9999 12.1684 17.9295 11.9555 17.7958C11.7419 17.6617 11.5709 17.4698 11.462 17.2424C11.3531 17.0148 11.3106 16.7606 11.3402 16.51C11.3699 16.2595 11.4704 16.0223 11.6293 15.8264C11.6417 15.8112 11.6547 15.7962 11.6684 15.7821L18.2686 8.98265C18.4144 8.82662 18.6061 8.72084 18.8168 8.68187ZM12.6684 16.6669H17.3331C17.5481 16.6665 17.7601 16.718 17.9509 16.8173C18.1422 16.9168 18.3069 17.0609 18.4301 17.2379C18.5533 17.4149 18.6316 17.6196 18.6586 17.8336C18.6841 18.0366 18.6603 18.242 18.5935 18.4351L18.5954 18.4358L17.751 21.0829L23.3318 15.3336H18.6664V15.3329C18.4516 15.3332 18.2398 15.2823 18.0492 15.1832C17.8579 15.0836 17.6933 14.9389 17.57 14.7619C17.4469 14.585 17.3685 14.3808 17.3415 14.1669C17.3159 13.9635 17.339 13.7574 17.406 13.564H17.4047L18.2484 10.9162L12.6684 16.6669Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4034_38995",
    x: 0,
    y: 0,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4034_38995"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4034_38995",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStation);
export default __webpack_public_path__ + "static/media/station.4f4511894535b1146e8395edd9b445cc.svg";
export { ForwardRef as ReactComponent };